import { request } from "@umijs/max";
import dayjs from 'dayjs'

export async function dcpList(body: {
    current?: number;
    pageSize?: number;
    dcpname?: string;
    dcppackageName?: string;
    status?: number
}, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Common.PageResult<Agent.DCP>>>('/filmpartnerapi/agent/getDCPList',
        {
            data: {
                pageIndex: body.current,
                pageSize: body.pageSize,
                dcpName: body.dcpname,
                dcpPackageName: body.dcppackageName,
                status: body.status
            }, options
        }
    ).then(res => {
        return {
            data: res.data.data,
            total: res.data.total,
            success: true
        }
    });
}

export async function usableDcpList(body: {
    current?: number;
    pageSize?: number;
    dcpname?: string;
    dcppackageName?: string;
}, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Common.PageResult<Agent.DCP>>>('/filmpartnerapi/agent/getDCPList',
        {
            data: {
                pageIndex: body.current,
                pageSize: body.pageSize,
                dcpName: body.dcpname,
                dcpPackageName: body.dcppackageName,
                status: 1
            }, options
        }
    ).then(res => {
        return {
            data: res.data.data,
            total: res.data.total,
            success: true
        }
    });
}

export async function deleteDcp(dcpIds: number[], options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.CPL[]>>('/filmpartnerapi/agent/deleteDcp', {
        data: {
            dcpIds: dcpIds
        }, options
    })
}

export async function cplList(body: Agent.DCP, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.CPL[]>>('/filmpartnerapi/agent/getCplList', {
        data: {
            dcpid: body.dcpid
        }, options
    })
}

export async function attachmentList(body: Agent.DCP, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.AgentAttachment[]>>('/filmpartnerapi/agent/getAttachmentList', {
        data: {
            dcpid: body.dcpid
        }, options
    });
}

export async function deleteAttachment(attachment: Agent.AgentAttachment, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.CPL[]>>('/filmpartnerapi/agent/deleteAgentAttachment', {
        data: attachment, options
    })
}


export async function planList(body: {
    current?: number;
    pageSize?: number;
    planName?: string;
    planState?: number;
}, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Common.PageResult<Agent.Plan>>>('/filmpartnerapi/agent/getPlanList',
        {
            data: {
                pageIndex: body.current,
                pageSize: body.pageSize,
                planName: body.planName,
                status: body.planState
            }, options
        }
    ).then(res => {
        return {
            data: res.data.data,
            total: res.data.total,
            success: true
        }
    });
}

export async function planResources(planCode: string, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.PlanResource[]>>('/filmpartnerapi/agent/getPlanResources', {
        data: {
            planCode: planCode
        }, options
    })
}

const dateFormat = 'YYYY-MM-DD';
export async function cinemaContract(beginDate: Date, endDate: Date, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.CinemaContract[]>>('/filmpartnerapi/agent/getContract', {
        data: {
            beginDate: dayjs(beginDate).format(dateFormat),
            endDate: dayjs(endDate).format(dateFormat)
        }, options
    })
}

export async function editPlan(plan: Agent.Plan, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/agent/editPlan', {
        data: plan, options
    })
}

export async function deletePlan(plan: Agent.Plan, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/agent/deletePlan', {
        data: plan, options
    })
}


export async function getCinemaPlanPlayRule(taskID: number, cinemaCode: string, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Agent.CinemaPlanPlayRule[]>>('/filmpartnerapi/agent/getCinemaPlanPlayRule', {
        data: {
            taskID: taskID,
            cinemaCodes: [cinemaCode]
        },
        options
    })
}


export async function arrangeCinemaList(body: {
    current?: number;
    pageSize?: number;
    arrangeStatus?: number;
    taskID?: number;
}, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Common.PageResult<Agent.ArrangeCinema>>>('/filmpartnerapi/agent/getArrangeCinemaList', {
        data: {
            pageIndex: body.current,
            pageSize: body.pageSize,
            status: body.arrangeStatus ?? -2,
            taskID: body.taskID
        }, options
    }
    ).then(res => {
        return {
            data: res.data.data,
            total: res.data.total,
            success: true
        }
    });
}

export async function editAgentArrange(agentArrangeList: Agent.AgentArrange[], options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/agent/editAgentArrange', {
        data: agentArrangeList, options
    })
}

export async function deleteAgentArrange(taskID: number, cinemaCodes: string[], options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/agent/deleteAgentArrange', {
        data: {
            taskID: taskID,
            cinemaCodes: cinemaCodes
        }, options
    })
}

export async function getAgentNotice(options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/agent/getAgentNotice', {
        options
    });
}


